import React from 'react';
import Styled from 'styled-components';
import InstructorModal from '@organisms/modals/InstructorModal';
import button from '@components/buttons';

const Button = Styled(button)`
  display: flex;
  align-items: center;
  margin-left: 5px;
`;

const InstructorWrapper = Styled.p`
  color: ${props => props.theme.colors.neutrals.black};
  padding-right: 10px;
`;

const Image = Styled.img`
  width: 40px;
  height: 40px;
`;

const CircleThumbnail = Styled.span`
  height: 40px;
  width: 40px;
  color: white;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;

  img:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-image: url(/static/profile-placeholder.svg);
    background-position: center center;
    background-size: cover;
  }
`;

const InstructorCircle = ({ className = '', instructor }) => {
  return (
    <InstructorModal slug={instructor.id}>
      {handleOpenModal => (
        <Button
          className={className}
          appearance="link"
          onClick={handleOpenModal}
        >
          <CircleThumbnail>
            <Image src={instructor?.assets?.squareImage} loading="lazy" />
          </CircleThumbnail>
          <InstructorWrapper>{instructor.name}</InstructorWrapper>
        </Button>
      )}
    </InstructorModal>
  );
};

export default InstructorCircle;
